import { Metric } from '@contentsquare/global-constants';
var MerchMetric;
(function (MerchMetric) {
    MerchMetric["AddToCartCount"] = "addToCartCount";
    MerchMetric["AddToCartRate"] = "addToCartRate";
    MerchMetric["RevenueSum"] = "revenueSum";
    MerchMetric["UniqueUsers"] = "uniqueUsers";
    MerchMetric["UnitSoldCount"] = "unitSoldCount";
    MerchMetric["ViewAverage"] = "viewAverage";
    MerchMetric["ViewCount"] = "viewCount";
    MerchMetric["VisitCount"] = "visitCount";
})(MerchMetric || (MerchMetric = {}));
export const MerchandisingMetric = Object.assign(Object.assign({}, MerchMetric), Metric);
//# sourceMappingURL=merchandising.metric.js.map